"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.profileButtons = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const routes_1 = require("~/consts/routes");
const passwordPolicy_1 = require("~/consts/passwordPolicy");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const UI_1 = require("~/components/UI");
const useActionToken_1 = __importDefault(require("~/hooks/useActionToken"));
const react_helmet_async_1 = require("react-helmet-async");
const ProfileHeadline_1 = __importDefault(require("../ProfileHeadline/ProfileHeadline"));
const ChangeCredentials_module_scss_1 = __importDefault(require("./ChangeCredentials.module.scss"));
const profileButtons = (closeHandler, submitHandler, isSubmitDisabled, t) => {
    return (react_1.default.createElement("div", { className: ChangeCredentials_module_scss_1.default.buttons },
        react_1.default.createElement("div", null,
            react_1.default.createElement(UI_1.Button, { wide: true, variant: "default", onClick: closeHandler }, t('cancel'))),
        react_1.default.createElement("div", null,
            react_1.default.createElement(UI_1.Button, { wide: true, variant: "primary", onClick: submitHandler, disabled: isSubmitDisabled }, t('submit')))));
};
exports.profileButtons = profileButtons;
// eslint-disable-next-line react/function-component-definition
function ChangeCredentials() {
    var _a, _b;
    const { t } = (0, react_i18next_1.useTranslation)('profile');
    const [email, setEmail] = (0, react_1.useState)('');
    const [password, setPassword] = (0, react_1.useState)('');
    const [newPassword, setNewPassword] = (0, react_1.useState)('');
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const [token, isTokenValid] = (0, useActionToken_1.default)((_a = searchParams.get('token')) !== null && _a !== void 0 ? _a : '');
    const pathname = location.pathname.replace('/user/', '');
    const initActionState = { status: '', message: '' };
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const { status, message } = (_b = (0, react_redux_1.useSelector)(selectors_1.selectAction)) !== null && _b !== void 0 ? _b : initActionState;
    const emailCustomErrors = {
        invalid: 'New email has a wrong format',
        required: 'New email is required',
    };
    const currentPasswordCustomErrors = {
        invalid: 'Current password is wrong',
        required: 'Current password is required',
    };
    const newPasswordCustomErrors = { invalid: 'New password is wrong', required: 'New password is required' };
    const { dispatChangePasswordAction, dispatchSendChangeEmailLink, dispatchChangeEmailAction, dispatchSetActionStatus, } = (0, redux_1.bindActionCreators)({
        dispatChangePasswordAction: actions_1.changePasswordAction,
        dispatchSendChangeEmailLink: actions_1.sendChangeEmailLink,
        dispatchChangeEmailAction: actions_1.changeEmailAction,
        dispatchSetActionStatus: actions_1.setActionStatus,
    }, (0, react_redux_1.useDispatch)());
    const closeHandler = () => {
        dispatchSetActionStatus(initActionState);
        navigate(routes_1.ROUTE_PROFILE, { replace: true });
    };
    const handleChangePassword = () => {
        dispatchSetActionStatus(initActionState);
        dispatChangePasswordAction({ password: newPassword, oldPassword: password });
    };
    const handleChangeEmail = () => {
        dispatchSetActionStatus(initActionState);
        dispatchSendChangeEmailLink({ newEmail: email, password });
    };
    (0, react_1.useEffect)(() => {
        if (isTokenValid && token) {
            dispatchChangeEmailAction(token);
            navigate('/', { replace: true });
        }
    }, [token, isTokenValid]);
    (0, react_1.useEffect)(() => {
        if (status === 'success') {
            closeHandler();
        }
    }, [status]);
    const isSubmitDisabled = pathname === 'email'
        ? email.trim() === '' ||
            password.trim() === '' ||
            password.trim().length < passwordPolicy_1.PASSWORD_MIN_LENGTH ||
            password.trim().length > passwordPolicy_1.PASSWORD_MAX_LENGTH
        : password.trim() === '' ||
            password.trim().length < passwordPolicy_1.PASSWORD_MIN_LENGTH ||
            password.trim().length > passwordPolicy_1.PASSWORD_MAX_LENGTH ||
            newPassword.trim() === '' ||
            newPassword.trim().length < passwordPolicy_1.PASSWORD_MIN_LENGTH ||
            newPassword.trim().length > passwordPolicy_1.PASSWORD_MAX_LENGTH ||
            password === newPassword;
    const isNewPasswordSameAsCurrent = pathname === 'password' && password !== '' && password === newPassword;
    return (react_1.default.createElement("div", { className: ChangeCredentials_module_scss_1.default.overlay },
        react_1.default.createElement(react_helmet_async_1.Helmet, null,
            react_1.default.createElement("title", null, pathname === 'email' ? 'Change Email | TBUILD' : 'Change Password | TBUILD')),
        react_1.default.createElement("div", { className: ChangeCredentials_module_scss_1.default.window },
            react_1.default.createElement("div", { className: ChangeCredentials_module_scss_1.default.modal },
                react_1.default.createElement(ProfileHeadline_1.default, { user: user, closeHandler: closeHandler, activeBlock: (0, exports.profileButtons)(closeHandler, pathname === 'email' ? handleChangeEmail : handleChangePassword, isSubmitDisabled, t), errorState: { status, message } }),
                react_1.default.createElement("div", { className: ChangeCredentials_module_scss_1.default.credentials },
                    pathname === 'email' && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: ChangeCredentials_module_scss_1.default.inputTitle },
                            " ",
                            t('change-credentials.email.email')),
                        react_1.default.createElement(UI_1.Input, { type: "email", maxLength: 255, placeholder: "Email", value: email, onChange: setEmail, onInput: setEmail, required: true, customErrors: emailCustomErrors }))),
                    react_1.default.createElement("div", { className: ChangeCredentials_module_scss_1.default.inputTitle }, t(`change-credentials.${pathname}.password`)),
                    react_1.default.createElement(UI_1.Input, { type: "password", placeholder: "********", value: password, onChange: setPassword, onInput: setPassword, minLength: passwordPolicy_1.PASSWORD_MIN_LENGTH, maxLength: passwordPolicy_1.PASSWORD_MAX_LENGTH, required: true, customErrors: currentPasswordCustomErrors }),
                    pathname === 'password' && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: ChangeCredentials_module_scss_1.default.inputTitle }, t('change-credentials.password.new-password')),
                        react_1.default.createElement(UI_1.Input, { type: "password", placeholder: "********", value: newPassword, onChange: setNewPassword, onInput: setNewPassword, minLength: passwordPolicy_1.PASSWORD_MIN_LENGTH, maxLength: passwordPolicy_1.PASSWORD_MAX_LENGTH, required: true, customErrors: newPasswordCustomErrors }),
                        isNewPasswordSameAsCurrent ? (react_1.default.createElement("div", { className: ChangeCredentials_module_scss_1.default.validationError }, t('change-credentials.password.same-as-current'))) : null)))))));
}
exports.default = ChangeCredentials;
